var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 108,
    viewBox: "0 0 119 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.16 39.17C71.79 39.17 63.27 38.83 55.3 36.61C47.48 34.44 40.3 30.23 33.9 25.36C29.71 22.19 25.9 19.66 20.46 20.04C15.1381 20.328 10.0488 22.3153 5.94001 25.71C-0.979991 31.77 0.0600085 43 2.83001 50.86C6.99001 62.73 19.65 71 30.41 76.35C42.84 82.56 56.5 86.17 70.19 88.24C82.19 90.07 97.61 91.39 108.01 83.56C117.56 76.35 120.18 59.91 117.84 48.81C117.272 45.5309 115.526 42.5721 112.93 40.49C106.22 35.58 96.21 38.86 88.67 39.02C85.87 39.08 83.02 39.15 80.16 39.17Z",
    fill: "#E6F2CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.08 107.7C80.3544 107.7 96.79 106.675 96.79 105.41C96.79 104.145 80.3544 103.12 60.08 103.12C39.8056 103.12 23.37 104.145 23.37 105.41C23.37 106.675 39.8056 107.7 60.08 107.7Z",
    fill: "#E6F2CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28003 17.12L21.28 16.02C22.9011 15.878 24.5218 16.2973 25.8707 17.2075C27.2196 18.1177 28.2149 19.4636 28.69 21.02L41.15 62.72L38.71 67.09C38.0833 68.216 37.7739 69.4909 37.8149 70.7789C37.8558 72.0669 38.2455 73.3196 38.9424 74.4035C39.6394 75.4874 40.6174 76.3619 41.7723 76.9336C42.9271 77.5053 44.2155 77.7529 45.5 77.65L95.4 73.41",
    stroke: "#80BC00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.55 27.35L88.55 22.43C89.1213 22.3811 89.6964 22.4614 90.2325 22.665C90.7686 22.8686 91.2519 23.1903 91.6467 23.6062C92.0415 24.0221 92.3376 24.5216 92.513 25.0676C92.6884 25.6135 92.7386 26.192 92.66 26.76L88.73 55.13C88.6106 55.9812 88.2085 56.7675 87.5881 57.3624C86.9678 57.9574 86.1654 58.3263 85.31 58.41L41.15 62.72L30.55 27.35Z",
    fill: "white",
    stroke: "#80BC00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.05 87.21C53.6512 87.21 55.76 85.1012 55.76 82.5C55.76 79.8987 53.6512 77.79 51.05 77.79C48.4487 77.79 46.34 79.8987 46.34 82.5C46.34 85.1012 48.4487 87.21 51.05 87.21Z",
    fill: "white",
    stroke: "#80BC00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.85 84.43C86.4513 84.43 88.56 82.3213 88.56 79.72C88.56 77.1187 86.4513 75.01 83.85 75.01C81.2488 75.01 79.14 77.1187 79.14 79.72C79.14 82.3213 81.2488 84.43 83.85 84.43Z",
    fill: "white",
    stroke: "#80BC00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5744 14.894L6.31847 15.9339C5.25638 16.0241 4.46844 16.9581 4.55856 18.0202C4.64868 19.0823 5.58273 19.8702 6.64483 19.7801L18.9008 18.7402C19.9629 18.6501 20.7508 17.716 20.6607 16.6539C20.5706 15.5918 19.6365 14.8039 18.5744 14.894Z",
    fill: "#80BC00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.97 49.26C55.2091 47.435 56.065 45.7465 57.3957 44.4747C58.7263 43.2029 60.4517 42.4242 62.2857 42.2678C64.1197 42.1114 65.9521 42.5866 67.4789 43.6147C69.0057 44.6427 70.1352 46.1618 70.68 47.92",
    stroke: "#80BC00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.81 38.47C71.4286 38.47 71.93 37.9685 71.93 37.35C71.93 36.7314 71.4286 36.23 70.81 36.23C70.1914 36.23 69.69 36.7314 69.69 37.35C69.69 37.9685 70.1914 38.47 70.81 38.47Z",
    fill: "#80BC00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.06 39.97C53.6786 39.97 54.18 39.4685 54.18 38.85C54.18 38.2314 53.6786 37.73 53.06 37.73C52.4414 37.73 51.94 38.2314 51.94 38.85C51.94 39.4685 52.4414 39.97 53.06 39.97Z",
    fill: "#80BC00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.51 81.11V85.42",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.36 83.26H23.66",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.22 0.98999V5.28999",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.07 3.14001H92.37",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.31 13.84V18.14",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.15 15.99H41.46",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.95 29.65C101.513 29.65 101.97 29.1933 101.97 28.63C101.97 28.0667 101.513 27.61 100.95 27.61C100.387 27.61 99.93 28.0667 99.93 28.63C99.93 29.1933 100.387 29.65 100.95 29.65Z",
    fill: "white",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.83 20.48C63.3712 20.48 63.81 20.0413 63.81 19.5C63.81 18.9588 63.3712 18.52 62.83 18.52C62.2887 18.52 61.85 18.9588 61.85 19.5C61.85 20.0413 62.2887 20.48 62.83 20.48Z",
    fill: "#E6F2CC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.41 91.6C69.9512 91.6 70.39 91.1613 70.39 90.62C70.39 90.0788 69.9512 89.64 69.41 89.64C68.8688 89.64 68.43 90.0788 68.43 90.62C68.43 91.1613 68.8688 91.6 69.41 91.6Z",
    fill: "#E6F2CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty-cart.2669a10e8be3451292cc8d619c985f45.svg";
export { ForwardRef as ReactComponent };